import React, { Fragment } from 'react';
import Collapsible from 'react-collapsible';
import ContainerHeader from 'components/ContainerHeader';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';


const BasicDetailDrillDown = ({ entries, title }) => {
    if (entries && Array.isArray(entries) && entries.length > 0) {
        return (
            <Fragment>
                <ContainerHeader title={title} />
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12">
                        {entries.map((entry, index) => {
                            return (
                                <Collapsible trigger={entry?.name} key={index} triggerStyle={{afterTop: 2, backgroundColor: 'black', paddingTop: 8, paddingBottom: 8}}>
                                    <div className="col-sm-12 text-center text-sm-left">
                                        <table className="default-table table table-sm table-responsive-sm table-hover">
                                            <tbody>
                                                <BasicDetailRow label={<IntlMessages id="label.description" />} description={entry?.description} />
                                            </tbody>
                                        </table>
                                    </div>
                                </Collapsible>
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    } else {
        return (
            <div className="row">
                <div className="col-md-12 col-12">
                    <Fragment>
                        <ContainerHeader title={title} />
                        <div className="mr-auto">
                            <h3 className="card-heading">No entries found here</h3>
                        </div>
                    </Fragment>
                </div>
            </div>
        );
    }
};

export default BasicDetailDrillDown;


// WEBPACK FOOTER //
// ./components/basicDetailDrillDown/index.js